import React from 'react';
import * as moment from 'moment';
import Help from '../HtmlHelpers';
import TableFilters from '../TableFilters';
const Moment = moment;
function changeValue(value, idx) {
  let val = typeof value === 'object' ? value[idx] : value || '';
  if (val === true) {
    val = 'Yes';
  }
  if (val === false) {
    val = 'No';
  }
  return val;
}
function change(id, values, type) {
  const changes = JSON.parse(values);
  const fields = Object.keys(changes);
  return fields.map(c => {
    const changeVal = changes[c] || '';
    const is = changeValue(changeVal, 1);
    const was = typeof changeVal === 'object' ? changeValue(changeVal, 0) : '';
    return /*#__PURE__*/React.createElement("div", {
      key: "log_".concat(id, "_").concat(c)
    }, /*#__PURE__*/React.createElement("b", null, "FIELD: "), c, /*#__PURE__*/React.createElement("br", null), "\xA0\xA0\xA0", /*#__PURE__*/React.createElement("b", null, "IS: "), is, /*#__PURE__*/React.createElement("br", null), type === 'create' ? '' : /*#__PURE__*/React.createElement("div", null, "\xA0\xA0\xA0", /*#__PURE__*/React.createElement("b", null, "WAS: "), was));
  });
}
const Columns = () => [{
  Header: 'Id',
  accessor: 'id',
  show: false
}, {
  Header: 'Change Type',
  accessor: 'event',
  className: 'text-center',
  width: 100
}, {
  id: 'changed_at',
  Header: 'Changed At',
  accessor: d => new Moment(d.created_at_utc).format('M/D/YYYY h:mm a'),
  className: 'text-left',
  sortMethod: Help.dateSort,
  width: 150
}, {
  Header: 'Changed By',
  accessor: 'username',
  className: 'text-left',
  width: 150
}, {
  id: 'changed',
  Header: 'Change',
  accessor: d => change(d.id, d.changed, d.event),
  className: 'text-left',
  filterMethod: (filter, row) => TableFilters.Default(filter, row._original),
  minWidth: 200
}];
export default Columns;